<div class="embed-video-overlay">
  <div class="embed-video-overlay__close" (click)="onClosed.emit(true)">CLOSE XXX</div>
  <brt-embed-video [data]="iframe"></brt-embed-video>
</div>
